var _path, _rect, _mask, _rect2, _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevvOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2359 13.0724H8.06641V9.13332L9.95212 7.26855H20.1978L21.9997 9.13332V14.2876L20.1978 16.0895H17.495L17.1388 16.4457V18.8343H12.9902V15.2724L14.8131 13.3866H17.5369L17.8302 13.0724V10.3066L17.495 9.99236H12.634L12.2359 10.3695V13.0724Z",
    fill: "#61A578"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.9688,
    y: 20.0913,
    width: 4.27429,
    height: 2.64,
    fill: "#61A578"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 22,
    height: 22,
    rx: 0.742857
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 22,
    height: 22,
    rx: 0.742857,
    stroke: "#61A578",
    strokeWidth: 1.82857,
    mask: "url(#path-3-inside-1)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.7575,
    cy: 6.24186,
    r: 0.859048,
    fill: "#61A578"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.7575,
    cy: 23.7582,
    r: 0.859048,
    fill: "#61A578"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.24186,
    cy: 23.7582,
    r: 0.859048,
    fill: "#61A578"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.24186,
    cy: 6.24186,
    r: 0.859048,
    fill: "#61A578"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevvOther);
export default __webpack_public_path__ + "static/media/revv_other.95beb814dec23790b22abfc260103037.svg";
export { ForwardRef as ReactComponent };